import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { Localization } from 'connex-cds';
import { assignmentStatusCode, isPendingStatusCode } from '../../../../../query-hooks/load-assignments';
import * as S from './styles';

export const AssignmentDetailsModal = ({ open, assignment, onClose }) => {
  const translateMessage = Localization.useTranslateMessage();
  const { timeZone } = Localization.useLocalizationContext();
  const { getShortDateTime } = Localization.useShortDateTime({ overrideTimeZone: timeZone });

  if (!assignment) return null;

  const statusCode = assignmentStatusCode(assignment);
  const statusLabel = assignment?.isActive
    ? translateMessage('loadAssignment_statusActive')
    : isPendingStatusCode(statusCode)
    ? translateMessage('loadAssignment_statusPending')
    : statusCode;
  const loadNumber = assignment?.loadNumber;
  const loadTime = assignment?.scheduledYardTime ? getShortDateTime(new Date(assignment.scheduledYardTime)) : '';

  const rows = [
    { label: translateMessage('gridHeader_loadTime'), value: loadTime },
    { label: translateMessage('gridHeader_orderNumber'), value: assignment?.orderId },
    {
      label: translateMessage('gridHeader_loadNumber'),
      value: loadNumber != null ? loadNumber : '',
    },
    { label: translateMessage('gridHeader_status'), value: statusLabel },
    {
      label: translateMessage('gridHeader_product'),
      value: assignment?.productName || assignment?.primaryProduct?.name,
    },
    { label: translateMessage('gridHeader_customer'), value: assignment?.customerName },
    { label: translateMessage('gridHeader_vehicle'), value: assignment?.vehicleId },
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth data-testid="assignment-details-modal">
      <DialogTitle>{translateMessage('loadAssignment_detailsTitle')}</DialogTitle>
      <DialogContent>
        {rows?.map?.(row => (
          <S.DetailRow key={row?.label}>
            <S.DetailLabel>{row?.label}</S.DetailLabel>
            <S.DetailValue>{row?.value || '—'}</S.DetailValue>
          </S.DetailRow>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="primary" data-testid="assignment-details-close">
          {translateMessage('loadAssignment_close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
